// extracted by mini-css-extract-plugin
export var tosLink = "_aw-0";